export default {
	title: 'Identifiez-vous avec FranceConnect',
	description: 'FranceConnect est la solution proposée par l\'État pour sécuriser et simplifier la connexion à vos services en ligne.'
};
